/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

//https://developers.google.com/custom-search/v1/reference/rest/v1/cse/list
//https://github.com/googleapis/google-api-nodejs-client/blob/main/src/apis/customsearch/v1.ts
export enum CSELanguageCode {
	ar = "ar",
	bg = "bg",
	ca = "ca",
	cs = "cs",
	da = "da",
	de = "de",
	el = "el",
	en = "en",
	es = "es",
	et = "et",
	fi = "fi",
	fr = "fr",
	hr = "hr",
	hu = "hu",
	id = "id",
	is = "is",
	it = "it",
	iw = "iw",
	ja = "ja",
	ko = "ko",
	lt = "lt",
	lv = "lv",
	nl = "nl",
	no = "no",
	pl = "pl",
	pt = "pt",
	ro = "ro",
	ru = "ru",
	sk = "sk",
	sl = "sl",
	sr = "sr",
	sv = "sv",
	tr = "tr",
	zh_CN = "zh-CN",
	zh_TW = "zh-TW",
}

export type CSEMaskedLanguageCode = `lang_${CSELanguageCode}`;
interface CSEStandardParameters {
	auth?: string;
	"$.xgafv"?: string;
	access_token?: string;
	alt?: string;
	callback?: string;
	fields?: string;
	key?: string;
	oauth_token?: string;
	prettyPrint?: boolean;
	quotaUser?: string;
	uploadType?: string;
	upload_protocol?: string;
}

export interface CSEParams extends CSEStandardParameters {
	c2coff?: string;
	cr?: string;
	cx?: string;
	dateRestrict?: string;
	enableAlternateSearchHandler?: boolean;
	exactTerms?: string;
	excludeTerms?: string;
	fileType?: string;
	filter?: string;
	gl?: string;
	googlehost?: string;
	highRange?: string;
	hl?: string;
	hq?: string;
	imgColorType?: string;
	imgDominantColor?: string;
	imgSize?: string;
	imgType?: string;
	key: string;
	linkSite?: string;
	lowRange?: string;
	lr?: CSEMaskedLanguageCode;
	num?: number;
	orTerms?: string;
	q?: string;
	relatedSite?: string;
	rights?: string;
	safe?: "active" | "off";
	searchType?: "image" | "";
	siteSearch?: string;
	siteSearchFilter?: "e" | "i";
	snippetLength?: number;
	sort?: string;
	start?: number;
}

export interface CSEQuery {
	count?: number;
	cr?: string;
	cx?: string;
	dateRestrict?: string;
	disableCnTwTranslation?: string;
	exactTerms?: string;
	excludeTerms?: string;
	fileType?: string;
	filter?: string;
	gl?: string;
	googleHost?: string;
	highRange?: string;
	hl?: string;
	hq?: string;
	imgColorType?: string;
	imgDominantColor?: string;
	imgSize?: string;
	imgType?: string;
	inputEncoding?: string;
	language?: string;
	linkSite?: string;
	lowRange?: string;
	orTerms?: string;
	outputEncoding?: string;
	relatedSite?: string;
	rights?: string;
	safe?: string;
	searchTerms?: string;
	searchType?: string;
	siteSearch?: string;
	siteSearchFilter?: string;
	sort?: string;
	startIndex?: number;
	startPage?: number;
	title?: string;
	totalResults?: string;
}

export interface CSERes {
	context?: {
		title: string;
	};
	items?: CSEImageSearchItem[];
	kind?: string;
	queries: {
		previousPage: CSEQuery[];
		nextPage: CSEQuery[];
		request: CSEQuery[];
	};
	searchInformation: {
		formattedSearchTime?: string;
		formattedTotalResults?: string;
		searchTime?: number;
		totalResults: string;
	};
	spelling?: { correctedQuery?: string; htmlCorrectedQuery?: string } | null;
	url?: { template?: string; type?: string } | null;
}

export interface CSESearchPageMapAsset {
	src: string;
	height?: string;
	width?: string;
}

export interface CSESearchPageMap {
	cse_image: CSESearchPageMapAsset[];
	cse_thumbnail: CSESearchPageMapAsset[];
	metatags: Record<string, string>[];
}
export interface CSESearchItem {
	cacheId?: string | null;
	displayLink?: string | null;
	fileFormat?: string | null;
	formattedUrl?: string | null;
	htmlFormattedUrl?: string | null;
	htmlSnippet?: string | null;
	htmlTitle?: string | null;
	kind?: string | null;
	labels?:
		| {
				displayName?: string;
				label_with_op?: string;
				name?: string;
		  }[]
		| null;
	link?: string | null;
	mime?: string | null;
	pagemap?: CSESearchPageMap;
	snippet?: string | null;
	title?: string | null;
}

export interface CSEImageSearchItem extends CSESearchItem {
	image?: {
		byteSize?: number;
		contextLink?: string;
		height?: number;
		thumbnailHeight?: number;
		thumbnailLink?: string;
		thumbnailWidth?: number;
		width?: number;
	} | null;
}

export interface CSESearchQuery {
	count: number;
	cx: string;
	inputEncoding: string;
	language: string;
	outputEncoding: string;
	safe: string;
	searchTerms: string;
	startIndex: number;
	title: string;
	totalResults: string;
}
